import useFormStateWithErrors from '@gr-monorepo/common/utils/useFormStateWithErrors';

export const defaultValue = {
  fio: '',
  workplacePosition: '',
  region: '',
  municipality: '',
  phone: '',
  email: '',
  text: '',
};

const defaultErrors = {
  fio: null,
  workplacePosition: null,
  region: null,
  municipality: null,
  phone: null,
  email: null,
  text: null,
};

const useFeedbackState = () => {
  return useFormStateWithErrors(defaultValue, defaultErrors);
};

export default useFeedbackState;

export type FeedbackState = ReturnType<typeof useFeedbackState>;
